import type { PayrollSummaryResult } from "@/modules/hr/payroll/domain/types";
import { Card, CardContent } from "@devhop/ui";
import { CheckCircle2, FileEdit, FileText } from "lucide-react";

type PayrollSummaryCardsProps = {
  data: PayrollSummaryResult | undefined;
  isLoading?: boolean;
};

export function PayrollSummaryCards({
  data,
  isLoading,
}: PayrollSummaryCardsProps) {
  const totalPaid = data?.totalPaid ?? 0;
  const pendingCount = data?.pendingCount ?? 0;
  const draftCount = data?.draftCount ?? 0;

  if (isLoading) {
    return (
      <div className="mb-6 grid gap-4 md:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <div key={i} className="animate-pulse rounded-xl border bg-card p-6">
            <div className="h-4 w-24 rounded bg-muted" />
            <div className="mt-2 h-8 w-32 rounded bg-muted" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="mb-6 grid gap-4 md:grid-cols-3">
      <Card>
        <CardContent className="flex items-center gap-4">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-muted text-muted-foreground">
            <CheckCircle2 className="h-5 w-5" />
          </div>
          <div>
            <p className="font-medium text-muted-foreground text-sm">
              ລວມລາຍການທີ່ຊຳລະແລ້ວ
            </p>
            <p className="font-semibold text-xl">
              {totalPaid.toLocaleString(undefined, {
                minimumFractionDigits: 2,
              })}
            </p>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="flex items-center gap-4">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-muted text-muted-foreground">
            <FileText className="h-5 w-5" />
          </div>
          <div>
            <p className="font-medium text-muted-foreground text-sm">
              ລໍຖ້າອະນຸມັດ
            </p>
            <p className="font-semibold text-xl">{pendingCount} ລາຍການ</p>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="flex items-center gap-4">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-muted text-muted-foreground">
            <FileEdit className="h-5 w-5" />
          </div>
          <div>
            <p className="font-medium text-muted-foreground text-sm">
              ເງິນເດືອນຮ່າງ
            </p>
            <p className="font-semibold text-xl">{draftCount} ພະນັກງານ</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
